import React, { useEffect, useState } from 'react'

const useSearchValue = (delay = 500) => {
    const [searchValue,setSearchValue] = useState('')
    const [debouncedSearchValue,setDebouncedSearchValue] = useState(searchValue);
    useEffect(() => {
        const handler = setTimeout(() => {
           setDebouncedSearchValue(searchValue) 
        },delay);
        return () => clearTimeout(handler);
    },[searchValue,delay]);
    return {
        searchValue,
        setSearchValue,
        debouncedSearchValue,
        setDebouncedSearchValue
    }
}

export default useSearchValue